import { Popup } from "@/components/dialog/Popup";
import BillPaymentReceiptPopover from "@/components/payment/BillPaymentReceiptPopover.vue";

import { TastierClient } from "@/app/TastierClient";
import { trans } from "@/app/localization/Trans";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class SendBillPaymentReceiptPopover extends VueContentPopover {
    constructor(paymentId: string) {
        super({ popoverClass: "sendreceipt", title: trans.receipt.receipt, fullscreen: false });

        const props = {
            paymentId: paymentId,
            locationId: TastierClient.context.currentAllocation!.locationId,
            userIsWaiter: TastierClient.identityContext?.isWaiterInCurrentLocation(),
            onSendReceiptSuccess: () => this.hide(),
            onPrintSuccess: () => {
                Popup.show({
                    message: trans.receipt.receiptPrinted,
                    confirmHandler: () => this.hide(),
                });
            },
        };
        this.initComponent(BillPaymentReceiptPopover, props);
    }
}
